var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Button, Card, Grid, GridColumn, RightDiv, Separator, Table } from "@atlassiansox/microscopekit";
import { ButtonGroup } from "@atlaskit/button";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
import TrashIcon from "@atlaskit/icon/glyph/trash";
export var SteadyStateView = function (props) {
    var parameters = props.steadyState.parameters;
    return (React.createElement(Card, null,
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 3 },
                React.createElement("p", null,
                    "Category: ",
                    props.steadyState.probeCategory),
                React.createElement("p", null,
                    "Action: ",
                    props.steadyState.probeAction)),
            React.createElement(GridColumn, { medium: 9 },
                React.createElement("div", { hidden: props.edit == null || props.delete == null },
                    React.createElement(RightDiv, null,
                        React.createElement(ButtonGroup, null,
                            React.createElement(Button, { iconBefore: React.createElement(EditFilledIcon, { label: "Edit" }), onClick: function (event) {
                                    props.edit
                                        ? props.edit(props.steadyState)
                                        : console.log("Nothing goes here");
                                } }),
                            React.createElement(Button, { iconBefore: React.createElement(TrashIcon, { label: "Delete" }), onClick: function (event) {
                                    props.delete
                                        ? props.delete(props.steadyState)
                                        : console.log("Nothing goes here");
                                } })))))),
        React.createElement(Separator, null),
        React.createElement(Table, { title: "Parameters", cells: Object.entries(parameters).map(function (entry) {
                var _a = __read(entry, 2), key = _a[0], value = _a[1];
                if (value != null) {
                    return [key, value.toString()];
                }
                else {
                    return [];
                }
            }), head: ["Key", "Value"] })));
};
